export default "__VITE_ASSET__BtK$CCRt__"